import { styled } from 'styles';

export const CardHeaderMeta = styled.div`
  color: ${({ theme }) => theme.card.meta.color};
  font-size: 0.9rem;
  font-weight: normal;
  margin-top: ${({ theme }) => theme.spacing.relative.small};
  word-break: break-word;
`;

export const StyledCardHeader = styled.div`
  border-bottom: thin solid ${({ theme }) => theme.card.header.border};
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: 600;
  padding: ${({ theme }) => theme.spacing.absolute.smaller}
    ${({ theme }) => theme.spacing.absolute.larger};
  user-select: none;
`;

CardHeaderMeta.displayName = 'CardHeaderMeta';
StyledCardHeader.displayName = 'CardHeader';
